export default {
  default: {
    error: ``,
    success: ``,
  },
  activate: {
    error: `Sorry, an error occurred registering your account, please try again`,
    400: `Some required fields are missing, please complete all required fields`,
    401: `Sorry, you don't have permission to register`,
    409: `A password has already been configured for your account. Please proceed to login.`,
    422: `Please make sure all provided fields are valid`,
  },
  login: {
    error: {
      skipEvaluationInWrapper: true,
      message: () => `Something went wrong while attempting to log in. You may have been blocked due to too many login attempts.`,
    },
    401: {
      skipEvaluationInWrapper: true,
      message: showWarning => (showWarning ?
        `Sorry, you’ve entered the wrong email and/or password. After too many attempts your account will be temporarily locked.` :
        `Sorry, you’ve entered the wrong email and/or password.`),
    },
    403: {
      skipEvaluationInWrapper: true,
      message: () => `Your account has been disabled.`,
    },
  },
  passwordReset: {
    error: `Sorry, an error occurred sending the password reset email, please try again`,
  },
  passwordResetConfirm: {
    error: `Sorry, an error occurred when resetting your password. You can request your password to be reset again.`,
    success: `Your password has successfully been updated. Please log in again.`,
    401: `Sorry, you don't have permission to reset this password. You can request your password to be reset again.`,
  },
  register: {
    error: `Sorry, an error occurred creating your account, please try again`,
    400: (error) => {
      const errorFields = _.get(error, 'response.data', {});
      const errorKeys = Object.keys(errorFields);
      const errorMessages = _.zipObject(errorKeys, errorKeys.map(key => errorFields[key].join(', ')));
      const combinedError = [`There are some problems with what you've entered`, ...errorKeys.map(key => `${key} ${errorMessages[key]}`)].join('<br />');
      return errorKeys.length ?
        combinedError :
        `Some required fields are missing, please complete all required fields`;
    },
    401: `Sorry, you don't have permission to create an account`,
    409: `Looks like this account already exists. Please log in`,
  },
  verifyEmail: {
    error: `Sorry, an error occurred verifying this email address`,
    success: {
      skipEvaluationInWrapper: true,
      message: authToken => (authToken ? `Your email address has been successfully verified` : `Your email address has been successfully verified, please log in again`),
    },
    401: `Sorry, the link you used to verify this email address is no longer valid, please log in to request another`,
    404: `Sorry, we couldn't locate your user account`,
    409: `Looks like you've already verified this email address, please log in`,
  },
};
